import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import LocalizedLink from '../../global/LocalizedLink'
import { Document, Page, pdfjs } from 'react-pdf'
import confirm from '../../global/extendedConfirm'
import Translation from '../../global/Translation'
import { handlePlanPdfDownload, getFormatConfigData, getCheckoutLineId, getConfigurablePlanPdfUrl } from '../utils'
import Spinner from '../../global/Spinner'
import { split } from 'lodash'

class ConfigCutToSizePlanAcceptance extends Component {
    constructor(props) {
        super(props)

        this.state = {
            numPages: null,
            isPlanAcceptanceChecked: false,
            isLeavingIntentionally: false,
            configurableDrawingIsLoading: true,
            refcodes: []
        }

        // Store intervalId to clear it later
        this.intervalId = null
    }

    componentDidMount() {

        this.syncCartWithConfigurator()

        this.props.setIsConfigurablePlanAcceptanceScreen(true)

        // Set the worker from CDN. DO NOT DELETE THIS. Is required for react-pdf
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

        // Use the worker from own source files. The file is place in public folder
        //pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`

        window.addEventListener('beforeunload', this.handleBeforeUnload)
        this.unblock = this.props.history.block((location, action) => {
            if (!this.state.isLeavingIntentionally && !this.state.isPlanAcceptanceChecked) {
                this.handleNavigationAttempt(() => {
                    this.setState({ isLeavingIntentionally: true }, () => {
                        this.unblock() // Allow the navigation after confirmation
                        this.props.history.push(location.pathname) // Proceed to the intended location
                    })
                })
                return false // Prevent navigation until confirmed
            }
            return true // Allow navigation if already leaving intentionally or plan is checked
        })

        if (this.props.refcode && this.props.configurableInProgress && this.props.configurableInProgress[this.props.refcode]) {
            const refCodes = []
            this.props.configurableInProgress[this.props.refcode].forEach((config) => {
                this.pollForDrawing(config.reference)
                refCodes.push(config.reference)
            })

            this.setState({ refcodes : refCodes })
        }
    }

    syncCartWithConfigurator() {
        Object.keys(this.props.deletedConfigurables).forEach(refCode => this.removeCartLineCutToSize(refCode))
        Object.keys(this.props.addConfigurables).forEach(refCode => this.addCartLineCutToSize(refCode))
        this.props.resetAddedAndDeletedConfigurables()
    }

    removeCartLineCutToSize = (refcode) => {
        const lineId = this.getCheckoutLineIdForCurrentConfig(refcode)
        this.props.removeCartLine(lineId)
    }

    addCartLineCutToSize = (refcode) => {
        const currentConfigInProgress = this.props.configurableInProgress[this.props.refcode]
        const currentConfig = currentConfigInProgress && currentConfigInProgress.find(config => config.reference === refcode)

        if (currentConfig) {
            this.props.addCartLine(1, this.getFormattedData(currentConfig))
        }
    }

    pollForDrawing(refcode) {
        this.setState({ configurableDrawingIsLoading: true })
        
        const maxAttempts = 5
        let attemptCount = 0
    
        const intervalId = setInterval(() => {
            attemptCount++
    
            this.props.fetchConfigurableDrawing(refcode)
                .then((response) => {
                    if (response.status === 200) {
                        const { exists, documentUrl } = response.data
    
                        if (exists && documentUrl) {
                            this.setState({ configurableDrawingIsLoading: false })
                            clearInterval(intervalId)
                        } else if (attemptCount >= maxAttempts) {
                            // Stop polling after maxAttempts if no documentUrl is generated
                            console.error('pollForDrawing -> Failed to generate URL after maximum attempts.')
                            this.setState({ configurableDrawingIsLoading: false })
                            clearInterval(intervalId)
                        }
                    } else {
                        // If the response status is not 200, stop polling
                        console.error('pollForDrawing -> Backend service is not available, stopping polling.');
                        this.setState({ configurableDrawingIsLoading: false })
                        clearInterval(intervalId)
                    }
                })
                .catch((error) => {
                    console.error('pollForDrawing -> Error fetching drawing:', error)
                    this.setState({ configurableDrawingIsLoading: false })
                    clearInterval(intervalId)
                })
    
        }, 4000) // Poll every 4 seconds
    }
    
    componentWillUnmount() {
        this.props.setIsConfigurablePlanAcceptanceScreen(false)
        
        window.removeEventListener('beforeunload', this.handleBeforeUnload)

        if (this.unblock) this.unblock()

        // Clear the interval if it's still running
        if (this.intervalId) {
            clearInterval(this.intervalId)
        }
    }

    // changeCartLineCutToSize = (config) => {
    //     this.props.changeCartLineCutToSize(this.getCheckoutLineIdForCurrentConfig(), this.getFormattedData(config))
    // }

    getCheckoutLineIdForCurrentConfig = (refcode) => {
        return getCheckoutLineId(this.props.checkoutLines, refcode)
    }

    handleBeforeUnload = (event) => {
        const { isPlanAcceptanceChecked, isLeavingIntentionally } = this.state
        
        // If the user is not intentionally leaving and the plan is not accepted, show confirmation
        if (!isLeavingIntentionally && !isPlanAcceptanceChecked) {
            event.preventDefault()
            event.returnValue = ''
        }
    }

    handleNavigationAttempt = (onConfirm) => {
        confirm(this.props.intl.formatMessage({ id: 'leave_page_plan_acceptance_confirmation_message' }), {
            isV2: true,
            advise: this.props.intl.formatMessage({ id: 'leave_page_plan_acceptance_advise_message' }),
            textCancel: this.props.intl.formatMessage({ id: 'cancel' }),
            textOk: this.props.intl.formatMessage({ id: 'leave_page_plan_acceptance_textok_message' })
        }).then(
            () => {
                onConfirm()
            },
            () => {
                return Promise.reject()
            }
        )
    }

    handleBackToEditClick = (event) => {
        event.preventDefault()
        const { location } = this.props

        // Extract the parts of the current location's pathname
        const currentPath = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
        const currentRef = this.props.configurableInProgress[this.props.refcode][0].reference
        const updatedPath = currentPath.replace("/configurable-plan-acceptance", "/configurables") + "/" + currentRef

        this.setState({ isLeavingIntentionally: true }, () => {
            this.props.history.push(updatedPath)
        })
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages })
    }

    handlePlanAcceptanceCheckboxChange = () => {
        this.setState(prevState => ({ isPlanAcceptanceChecked: !prevState.isPlanAcceptanceChecked }))
    }

    getFormattedData = (config) => {
        const { isPlanAcceptanceChecked } = this.state
        const { intl, units, refcode, configurableDrawingList } = this.props
        const url = configurableDrawingList[refcode] && configurableDrawingList[refcode].documentUrl

        return getFormatConfigData(config, isPlanAcceptanceChecked, intl.locale, units, url, refcode)
    }

     handlePlanAcceptance = () => {
        const { history, configurableInProgress, addCartLine, changeCartLineCutToSize, addConfigurablePlanAcceptanceChecked, localizedUrl, configurableModifiedList } = this.props
        const { isPlanAcceptanceChecked } = this.state
    
        if (isPlanAcceptanceChecked) {
            const cartLine = []
            let letAddToCart = false
            const currentConfigInProgress = configurableInProgress[this.props.refcode]
            const isModified = configurableModifiedList[this.props.refcode] ? configurableModifiedList[this.props.refcode].isConfigurableModified : null
            addConfigurablePlanAcceptanceChecked(this.props.refcode, true)

            if (currentConfigInProgress) {
                this.state.refcodes.forEach(refcode => {
                    const currentConfig = currentConfigInProgress.find(config => config.reference === refcode)
                    try {
                        const lineId = this.getCheckoutLineIdForCurrentConfig(refcode)
                        if (lineId) {
                            console.log('ACCEPTED plan', refcode)
                            if (isModified === true) {
                                // Update the existing cart line
                                changeCartLineCutToSize(lineId, this.getFormattedData(currentConfig))
                            }
                        } else {
                            letAddToCart = true
                            console.log('ACCEPTED plan addCartLine')
                            // Add new item to the cart
                            cartLine.push(this.getFormattedData(currentConfig))
                        }
                    } catch(error) {
                        console.error('handlePlanAcceptance -> Failed to update the state', error)
                    }
                })
            }

            if (letAddToCart) {
                addCartLine(1, cartLine)
            }
            const routePath = localizedUrl('ROUTE_CHECKOUT')
            history.push(routePath)
        }
    }

    getPlanPdfUrls = () => {
        const { configurableDrawingList } = this.props
        const planUrls = []
        this.state.refcodes.forEach(refcode => {
            const planUrl = getConfigurablePlanPdfUrl(configurableDrawingList, refcode)
            if (planUrl) planUrls.push(planUrl)
        })

        return planUrls
    }

    onDownloadClick = (urls) => {
        const { model } = this.props
        urls.forEach(url => {
            handlePlanPdfDownload(url, model)
        })
    }

    getPreparedUrlsForDownload = () => {
        const planUrls = this.getPlanPdfUrls()
        const planUrlsForDownload = []
        planUrls.forEach(planUrl => {
            planUrlsForDownload.push( process.env.REACT_APP_API_HOST + '/helper/view-pdf-url/?url=' + encodeURIComponent(planUrl))
        })

        return planUrlsForDownload
    }

    render() {
        const { model, refcode, fabricator, triggerConfirmAddToCartConfiguration, configurableInProgress} = this.props
        const { isPlanAcceptanceChecked, numPages, configurableDrawingIsLoading } = this.state

        const planUrlsForDownload = this.getPreparedUrlsForDownload()

        const checkbokAndButtonBlock = (
            <div className="accept-plan-checkbox">
                <div className="checkbox-block">
                    <div>
                        <input type="checkbox" id="accept-checkbox" checked={isPlanAcceptanceChecked} onChange={this.handlePlanAcceptanceCheckboxChange} />
                    </div>
                    <div>
                        <label htmlFor="accept-checkbox">
                            <Translation id="config_plan_acceptance_agreement_with_drawing" defaultMessage="I agree with the drawing and the information included in it for ordering the product." />
                        </label>
                    </div>
                </div>
                <div className="button-block">
                    <button
                        onClick={() => {
                            triggerConfirmAddToCartConfiguration()
                            this.handlePlanAcceptance()
                        }}
                        disabled={!isPlanAcceptanceChecked}
                        className="accept-plan-button"
                    >
                        <Translation id="continue" defaultMessage="Continue" />
                    </button>
                </div>
            </div>
        )

        return (
            <div className="container config__plan__acceptance">
                <div className="config__plan__acceptance--back-btn">
                    <LocalizedLink
                        routeId="ROUTE_CONFIG_CUT_TO_SIZE" 
                        params={{ model: model, refcode: refcode, fabricator: fabricator }}
                        onClick={(event) => this.handleBackToEditClick(event)}
                        gtmLabel="custom-products-catalog_link_back-to--configuration"
                    >
                        <button>
                            <i className="fas fa-chevron-left"></i>
                            <Translation id="back_to_edit" defaultMessage="Back to edit" />
                        </button>
                    </LocalizedLink>
                </div>
                <section className="config__plan__acceptance--content-container">
                    <div className="main-heading">
                        <h1><Translation id="config_plan_acceptance_review_and_accept_the_plan" defaultMessage="Review and accept the plan" /></h1>
                    </div>
                    <div className="pdf-text-content">
                        <div className="pdf-viewer">
                            {configurableDrawingIsLoading ? (
                                <Spinner isLoading={true} innerCenter />
                            ) : (planUrlsForDownload.map(url => {
                                    return (
                                        <Document
                                            file={url}
                                            onLoadSuccess={this.onDocumentLoadSuccess}
                                            className="config-plan-acceptance-document"
                                            loading={<Translation
                                                id="config_plan_acceptance_plan_display_is_being_generated"
                                                defaultMessage="The plan display is being generated, this may take a few seconds." />}
                                            onLoadError={console.error}
                                        >
                                            {Array.from(new Array(numPages), (el, index) => (
                                                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                                            ))}
                                        </Document>
                                    )
                                })
                            )}
                        </div>
                        <div className="text-checkbox">
                            <div>
                                <p className="main-paragraph">
                                    <Translation id="config_plan_acceptance_review_the_document_containing_the_drawing" defaultMessage="Please review the document containing the drawing and all the technical information of the product you are going to buy." />
                                </p>

                                <p className="second-paragraph">
                                    <Translation id="config_plan_acceptance_remember_the_acceptance_will_be_used_for_order" defaultMessage="Remember that the acceptance of this plan implies the acceptance of the document and all the information contained in it and that it will be used for the realization of the order of the requested product." />
                                </p>

                                <p className="normal-paragraph">
                                    <Translation id="config_plan_acceptance_review_the_document_prior" defaultMessage="It is important that you review the document prior to acceptance." />
                                </p>
                                {planUrlsForDownload.length > 0 && (
                                    <React.Fragment>
                                        <div className="downlow-plan-acceptance">
                                            {planUrlsForDownload.map(url => {
                                                return (
                                                    <button onClick={() => handlePlanPdfDownload(url, model)}
                                                            gtm-label="custom-products-catalog_download_download--custom-products-catalog"
                                                    >
                                                        <i className="fas fa-download" />
                                                        <Translation id="download_map" defaultMessage="Download map" />
                                                    </button>
                                                )
                                            })}
                                        </div>
                                        {Object.keys(configurableInProgress).length > 0 && checkbokAndButtonBlock}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default withRouter(ConfigCutToSizePlanAcceptance)
